export const DISCARD_CHANGES_MODAL_TITLE = "Discard Changes";
export const DISCARD_CHANGES_MODAL_DESC =
  "You have made changes to your submitted feedback. If you cancel now, your modifications will not be saved. Are you sure you want to discard these changes?";
export const DISCARD_CHANGES_MODAL_YES_BUTTON = "Yes, discard changes";
export const DISCARD_CHANGES_MODAL_KEEP_EDITING = "Keep editing";
